import { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import logo from '@assets/images/logo.svg';
import styles from '@components/EventPreloader/EventPreloader.module.css';

export default function EventPreloader({ isLoading, className }) {
  const [visible, setVisible] = useState(isLoading);
  useEffect(() => {
    if (isLoading) {
      setVisible(true);
    } else {
      const timer = setTimeout(() => {
        setVisible(false);
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);
  return (
    <div
      className={clsx(
        styles.preloader,
        { [styles.hidden]: !visible },
        className,
      )}
    >
      <div className={styles.logoWrapper}>
        <img src={logo} alt="Logo" className={styles.logo} />
      </div>
    </div>
  );
}

EventPreloader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

EventPreloader.defaultProps = {
  isLoading: true,
};
